import { useState, useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import NavigationBar from "../components/NavigationBar.js";
import seriesStore from "../stores/seriesStore.js";
import statusStore from "../stores/statusStore.js";
import seasonStore from "../stores/seasonStore.js"
import Header from "../components/Header.js";
import Footer from "../components/Footer.js";
import activityLogStore from "../stores/activityLogStore.js";


export default function ActivityLog() {

    const serStore = seriesStore();
    const staStore = statusStore();
    const seaStore = seasonStore();
    const actStore = activityLogStore();

    const [selectedShow, setSelectedShow] = useState(null);
    const [selectedSeriesList, setSelectedSeriesList] = useState(null);
    const [activeHeader, setActiveHeader] = useState(false);

    // Runs the function on load
    useEffect(() => {
        serStore.fetchSeries();
        staStore.fetchStatus();
        seaStore.fetchSeason();
        actStore.fetchActivityLog();
    }, []);

    const logs = actStore.activityLog;
     
    const seriesTitleById = Object.fromEntries(
      serStore.series?.map((s) => [s._id, s.title]) || []
    );

    const sortedLogs = [...logs]
    .sort((a, b) => new Date(b.updatedAt) - new Date(a.updatedAt));

    function timeAgo(date) {
        const diffMs = Date.now() - new Date(date).getTime();
        const hours = Math.floor(diffMs / (1000 * 60 * 60));

        if (hours < 1) return "just now";
        if (hours < 24) return `${hours}h`;

        const days = Math.floor(hours / 24);
        return `${days}d`;
    }

    return (
        <div className="app-wrapper tv-static">
            <header class="header">
                <Header 
                    selectedShow={selectedShow}
                    setSelectedShow={setSelectedShow}
                    selectedSeriesList={selectedSeriesList}
                    setSelectedSeriesList={setSelectedSeriesList}
                    activeHeader={activeHeader}
                    setActiveHeader={setActiveHeader}
                />
            </header>
            <content className="content">
                <nav className="nav">
                    <NavigationBar 
                        selectedShow={selectedShow}
                        setSelectedShow={setSelectedShow}
                        selectedSeriesList={selectedSeriesList}
                        setSelectedSeriesList={setSelectedSeriesList}
                        activeHeader={activeHeader}
                        setActiveHeader={setActiveHeader}
                    />
                </nav>
                <main className="main">
                    <h2 className="activityLogHeader">Activity Log</h2>
                    <div className="activityLog">
                        <ul>
                            {sortedLogs.map((entry) => (
                                <li key={entry._id || entry.seriesId}>
                                    <div>You marked <span className="spanWhite">{seriesTitleById[entry.seriesId]}</span> as <span className="spanWhite">{entry.userStatus}</span></div> 
                                    <div className="activityLogTime">{timeAgo(entry.updatedAt)}</div>
                                </li>
                            ))}
                        </ul>
                    </div>
                </main>
                <aside className="right">
                    <div className="rightPanel">
                    </div>
                </aside>
            </content>
            <div class="footer"><Footer/></div>
        </div>
    )
}